import Phaser from "phaser"

import { cScene } from "../cScene";
import { Base, ModuleCollection } from "./modules";
import { helper } from "./helper";
import { ScreenItem } from "../dataTypes";
import { getStr } from "../utils/simpleLocalisation";

export class cButton extends Phaser.GameObjects.Container {

  public readonly isContainer: boolean = true;

  public modules: ModuleCollection;

  private txt?:Phaser.GameObjects.Text
  private bg:Phaser.GameObjects.Sprite
  private icon:Phaser.GameObjects.Sprite | undefined
  public events: Phaser.Events.EventEmitter
  private _data: ScreenItem

  private snd_over: string = "sound_over";
  private snd_click: string = "sound_click";

  private selectedState: boolean
  private _hoverTint: number | null

  public propsOnDown: any 
  public propsOnUp: any 

  constructor(sc:cScene, data: ScreenItem){
    super(sc,0,0)
    this.modules = Base.initModules(this,data);
    this._hoverTint = null;
    this.selectedState = false

    this._data = data;
    this.events = new Phaser.Events.EventEmitter()  

    this.bg = new Phaser.GameObjects.Sprite(sc,0,0, String(data.asset));
    this.add(this.bg);

    if (data.sounds && data.sounds['sound_over']) this.snd_over = data.sounds['sound_over'];
    if (data.sounds && data.sounds['sound_click']) this.snd_click = data.sounds['sound_click'];

    this.bg.setInteractive({ useHandCursor: true });

    this.bg.on('pointerover',()=>{    
      this.bg.setFrame(this.selectedState ? 3 : 1)
      sc.snd( this.snd_over );
      if (this._hoverTint) this.bg.setTint(this._hoverTint)

    });
    this.bg.on('pointerout',()=>{
      this.bg.setFrame(this.selectedState ? 3 : 0)
      this.bg.clearTint()
    });

    var $this = this;
    
    this.bg.on('pointerdown',()=>{
      this.bg.setFrame(this.selectedState ? 3: 2)    
      if (this._hoverTint) this.bg.setTint(this._hoverTint)

      if ($this.propsOnDown){
        Object.keys($this.propsOnDown).forEach( (k)=>{
          ($this as any)[k]=$this.propsOnDown[k]
        })
      }
    });

    this.bg.on('pointerup',()=>{
      this.bg.setFrame(this.selectedState ? 3 : 1)
      sc.snd( this.snd_click );
      this.events.emit('click', this._data)   

      if ($this.propsOnUp){        
        Object.keys($this.propsOnUp).forEach( (k)=>{
          ($this as any)[k]=$this.propsOnUp[k] 

        })
      }
    });

    if (data.text){
      this.txt = helper.createTextfield(sc, getStr(data.text) , this._data.textclass || 'btn', this._data.textstyle )      
      this.txt.setOrigin(0.5,0.5)
      var s:any = sc.getStyle( String(this._data.textclass));
      if (s.shiftY) this.txt.y = s.shiftY;
      if (s.shiftX) this.txt.x = s.shiftX;
      this.add(this.txt)
    }

    if (data.extra_asset){
      var [asset,frame] = String(data.extra_asset).split(':');
      this.icon = new Phaser.GameObjects.Sprite(sc,0,0,asset,frame );
      this.add(this.icon);
    }
  }


  public setIconFrame(fr:any){
    if (this.icon){
      this.icon.setFrame(fr)
    }
  }

  public get _height():number {
    return this.bg.height;
  }

  public set text ( v:string ){
    if (this.txt){
      this.txt.text = getStr(v);
    }
  }

  public get flipY(): boolean{
    return (this.bg) ? this.bg.flipY : false;
  }

  public set flipY ( v:boolean ){
    if (this.bg) this.bg.flipY = v;
  }

  public set enabled (v:boolean){
    if (!this.scene) return 
    v ? this.bg.setInteractive({ useHandCursor: true }) : this.bg.disableInteractive()
  }

  public set iconRotation (v:number){
    this.bg.angle = v
  }

  public set hoverTint (v:string){
    this._hoverTint = parseInt(v,16)
  }

  public setSelectedState(opt:boolean){
    this.selectedState = opt
    this.bg.setFrame(opt ? 3 : 0)
  }

  public set applyDown(opt:string){
    console.log('APPLY DOWN',opt)
    switch (opt){
      case 'scale':
        this.propsOnDown = {'scaleX':0.95, 'scaleY':0.95}
        this.propsOnUp = {'scaleX':1,'scaleY':1}
        break;
    }
  }


}